import { SxProps, Theme } from '@mui/material';
import { BRAND } from './branding';

export const gradientButtonSx: SxProps<Theme> = {
  background: BRAND.gradient,
  color: '#fff',
  fontWeight: 700,
  boxShadow: `0 4px 24px ${BRAND.colors.glow}`,
  '&:hover': {
    background: BRAND.gradient,
    filter: 'brightness(1.08)',
    boxShadow: `0 6px 32px ${BRAND.colors.glow}`,
  },
};

export const darkCardSx: SxProps<Theme> = {
  bgcolor: BRAND.colors.surface,
  border: `1px solid ${BRAND.colors.border}`,
  borderRadius: 3,
  transition: 'border-color 0.2s, box-shadow 0.2s',
  '&:hover': {
    borderColor: 'rgba(0, 212, 255, 0.28)',
    boxShadow: `0 8px 32px rgba(0, 0, 0, 0.4), 0 0 24px rgba(0, 212, 255, 0.08)`,
  },
};

export const publicPageSx: SxProps<Theme> = {
  color: BRAND.colors.text,
  '& .MuiTypography-root': {
    color: 'inherit',
  },
};

export const glowOrbSx = (size: number, top: string, left: string, opacity = 0.2): SxProps<Theme> => ({
  position: 'absolute',
  width: size,
  height: size,
  top,
  left,
  borderRadius: '50%',
  background: BRAND.gradient,
  opacity,
  filter: 'blur(80px)',
  pointerEvents: 'none',
});

export const authCardSx: SxProps<Theme> = {
  p: 4,
  width: '100%',
  bgcolor: BRAND.colors.surface,
  border: `1px solid ${BRAND.colors.border}`,
  borderRadius: 3,
  boxShadow: `0 16px 48px rgba(0,0,0,0.45)`,
};

export const authFieldSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    color: BRAND.colors.text,
    '& fieldset': { borderColor: BRAND.colors.border },
    '&:hover fieldset': { borderColor: 'rgba(0,212,255,0.35)' },
    '&.Mui-focused fieldset': { borderColor: BRAND.colors.primary },
  },
  '& .MuiInputLabel-root': { color: BRAND.colors.textDim },
  '& .MuiInputLabel-root.Mui-focused': { color: BRAND.colors.primary },
  '& .MuiFormHelperText-root': { color: BRAND.colors.textDim },
};
